import React from 'react';

const SearchLoadingIcon: React.FC = () => (
  <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M92.75 92.75L83.1438 83.1438L73.5375 73.5375M84.3031 81.9844L93.9094 91.5906L91.5906 93.9094L81.9844 84.3031M83.9167 48.5833C83.9167 68.0974 68.0974 83.9167 48.5833 83.9167C29.0693 83.9167 13.25 68.0974 13.25 48.5833C13.25 29.0693 29.0693 13.25 48.5833 13.25C68.0974 13.25 83.9167 29.0693 83.9167 48.5833Z"
      stroke="#475467"
      strokeWidth="4.58599"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.875 34.6875C36.7725 34.6875 37.5 35.415 37.5 36.3125V57.4375C37.5 59.6812 39.3188 61.5 41.5625 61.5H65.125C66.0225 61.5 66.75 62.2275 66.75 63.125C66.75 64.0225 66.0225 64.75 65.125 64.75H41.5625C37.5239 64.75 34.25 61.4761 34.25 57.4375V36.3125C34.25 35.415 34.9775 34.6875 35.875 34.6875Z"
      fill="#00A389"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.5 56.4408L44.2896 48.9723L48.7793 51.7783C49.9416 52.5048 51.4566 52.2988 52.3828 51.2884L60.6354 42.2856C61.2418 41.624 61.1971 40.5961 60.5356 39.9896C59.874 39.3832 58.8461 39.4279 58.2396 40.0895L50.2153 48.8433L45.7244 46.0364C44.5583 45.3077 43.0379 45.5176 42.113 46.535L37.5 51.6093V56.4408Z"
      fill="#10A890"
    />
  </svg>
);

export default SearchLoadingIcon;
